module.exports = __webpack_public_path__ + "static/media/cafe_nordoy_thumb_even.85fd4877.jpg";